﻿import * as React from "react";
import PickersTextField from "./PickersTextField";
import { Calendar } from "./icons";
import { DatePicker as MaterialDatePicker, DatePickerProps as MaterialDatePickerProps } from "@mui/x-date-pickers-pro";
import { getDataProps } from "../../shared/utilities";

export interface DatePickerProps extends MaterialDatePickerProps {
    name?: string;
    placeholder?: string;
    helperText?: string;
    error?: boolean;
}

const DatePicker: React.FunctionComponent<DatePickerProps> = React.forwardRef((props: DatePickerProps, ref: any) => {
    const { slots: _slots, error, helperText, ...rest } = props;

    const slots = React.useMemo(() => {
        return {
            openPickerIcon: Calendar,
            textField: (params) => <PickersTextField {...params} size="small" error={error} helperText={helperText} fullWidth />,
            ..._slots,
        };
    }, [_slots, error, helperText])

    return (
        <div className="date-picker-container" {...getDataProps(rest)}>
            <MaterialDatePicker
                ref={ref}
                slots={slots}
                format="yyyy/MM/dd"
                {...rest}
            />
        </div>
    );
});

export default DatePicker;